<label class="form-label d-block text-truncate" [for]="id" [title]="labelName">
  {{ labelName }}
  @if (required && !disabled && !readonly && !control.disabled) {
    <span class="ml-1 text-danger">*</span>
  }
  @if (checkCyrillic && cyrillicChars.length > 0) {
    <span class="form-label warning-message text-warning text-wrap" [title]="cyrillicChars">
      ({{ cyrillicWarningMessage }}: {{ cyrillicChars }})
    </span>
  }
</label>

<input
  [name]="name"
  [title]="value ?? ''"
  title="Название поля"
  [id]="id"
  [required]="required"
  [disabled]="disabled"
  [readonly]="readonly || disabled || control.disabled"
  [placeholder]="readonly || disabled ? '' : placeholder"
  [value]="value ?? control.value"
  [maxLength]="maxLength"
  [minLength]="minLength"
  [attr.step]="step ?? null"
  [attr.min]="min ?? null"
  [attr.max]="max ?? null"
  [ngClass]="{
    'form-control-plaintext': plaintext,
    'form-control': !plaintext,
    'is-invalid': control.invalid && control.touched && !plaintext,
    uppercase: uppercase
  }"
  [type]="showPassword ? 'text' : type"
  [data-test-id]="(testId || name) || null"
  (input)="onChange($any($event.target).value)"
  (blur)="onBlur($event)"
  (keypress)="onKeyPress($event)"
  (paste)="onPaste($event)"
/>

@if (type === 'password') {
  <span
    class="eye-icon"
    [ngClass]="{ 'invalid-eye-icon': control.invalid && control.touched && !plaintext }"
    (click)="togglePasswordVisibility()"
  >
    <i [class]="showPassword ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
  </span>
}

@if (control.invalid && !this.disabled && !this.readonly) {
  <div class="invalid-feedback">
    {{ getErrorMessage() }}
  </div>
}
